<template>
  <div>
    <v-row>
      <v-spacer/>
      <v-spacer/>  
      <v-col>      
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          class="ml-1"
          single-line
          hide-details
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="1">            
        <v-btn outlined color="primary" :disabled="filteredResults?.length == 0"
              v-on:click="csvExport()">
            <font-awesome-icon icon="file-download" size="lg" />
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="showResultsHeaders"
          :items="filteredResults"
          :search="search"
          dense
          show-group-by
          :sort-by="['showDate', 'showId']"
          :sort-desc="[false, false]"
          multi-sort
          :items-per-page="-1"
          fixed-header
          height="101vh"
        >
          <template v-slot:item.showDate="{ item }">
            <localized-date :date="item.showDate" />
          </template>
          <template v-slot:item.showId="{ item }">
            <router-link
              :to="`/admin/shows/${item.showId}`"
              target="_blank"
              >{{ item.showId }}</router-link
            >
          </template>
          <template v-slot:item.judge="{ item }">
            <router-link :to="`/admin/people/${item.judgePersonId}`" 
              target="_blank">{{
              item.judge + " - " + item.judgeId
            }}</router-link>
          </template>
          <template v-slot:item.transferredToAce="{ item }">
            <font-awesome-icon
              v-if="item.transferredToAce !== null"
              :icon="item.transferredToAce ? 'check' : 'times'"
              :color="item.transferredToAce ? 'green' : 'red'"
            />
            <span v-else></span>
          </template>
          <template v-slot:item.isScchMajor="{ item }">
            <span v-if="item.isScchMajor != null">
              {{ item.isScchMajor ? 'Yes' : 'No' }}
            </span>
            <span v-else></span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import dogService from "@/services/dogService";
import { UserInfo } from "@/types/User";
import { getUserToday } from "@/helpers/date-utils";
import { downloadCsv } from "@/helpers/download-csv";
export default Vue.extend({
  name: "ShowResults",
  props: {
    dogId: String,
  },
  data: function () {
    return {
      showResultsHeaders: [
        { text: "Show Date", align: "left", value: "showDate", width: "100px" },
        { text: "Show ID", align: "left", value: "showId", width: "100px" },
        { text: "Descr.", align: "left", value: "description", width: "100px" },
        { text: "Category", align: "left", value: "category", width: "50px" },
        { text: "Division", align: "left", value: "division", width: "50px" },
        { text: "Score", align: "left", value: "score", width: "50px" },
        { text: "Transferred to ACE", align: "left", value: "transferredToAce" },
        { text: "Place", align: "left", value: "place" },
        { text: "Hit", align: "left", value: "hit" },
        { text: "Pt Sched.", align: "left", value: "ptSched" },
        { text: "# Competing", align: "left", value: "nCompeting" },
        { text: "SCCH Score", align: "left", value: "scchScore" },
        { text: "SCCH Major", align: "left", value: "isScchMajor" },
        { text: "Judge", align: "left", value: "judge" },
        { text: "Handler", align: "left", value: "handler" },
      ],
      filteredResults: [],
      search: "",
    };
  },
  methods: {    
    csvExport: function () {
      const filename = `ShowResults_${this.dogId?.trim()}_${getUserToday()}.csv`;
      downloadCsv(filename, this.filteredResults);
    },
  },
  created: function () {
    dogService
      .getDogShowResultsById(this.dogId)
      .then((res) => {
        this.filteredResults = res.data;
      })
      .catch(this.$handleError);
  },
  watch: {
    dogId: function (newVal: string) {
      dogService
        .getDogShowResultsById(newVal)
        .then((res) => {
          this.filteredResults = res.data;
        })
        .catch(this.$handleError);
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
